import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdateTrackOrder, RemoveTrack } from '../action-creators';
import AppState from '../../state';
import { REMOVE_TRACK } from '../actions';
import { trackList } from '../selectors';
import { TrackOrderUpdate } from '@services/track/types/track-order-update';

export const orderAfterRemoveEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, RemoveTrack>(REMOVE_TRACK),
    withLatestFrom(state$),
    filter(
      ([_, state]) =>
        !!trackList(state.tracks.tracks, state.release.release?.id).length
    ),
    map(([action, state]) => {
      const tracks = trackList(
        state.tracks.tracks,
        state.release.release?.id || action.releaseId
      );
      const order: TrackOrderUpdate[] = tracks.map((t, i) => ({
        id: t.id as string,
        order: i + 1,
      }));

      return new UpdateTrackOrder(
        order,
        state.release.release?.id || action.releaseId
      );
    })
  );
